<template>

    <div id="lt_downloads">
        
        <h3 style="margin-bottom:25px">הורדות</h3>
        <ul>
            <li v-for="down in list" :key="down.name">
                <a :class="'item ' + (down.is_active ? 'active' : '')" @mousedown="validateDownload(down)" @click="(down.type == 'download' ? show_download= !show_download : null); (down.type == 'download' ? down.is_active = !down.is_active : null)" :href="(down.url != '' ? down.url : null)">
                    <i :class="down.icon"></i>
                    <span v-text="down.name"></span>
                </a>
            </li>
        </ul>

        <div v-if="show_download" class="formats">
            <div style="margin-bottom:25px">בחר פורמט להורדת השיר</div>
            <a v-for="format in song_formats" :key="format.name" class="song_down" :href="format.link"><i class="far fa-file"></i><span v-text="format.name"></span></a>
        </div>

    </div>
</template>

<script>

export default {
  props: ["item"],
  data(){
    return {
        show_download: false,
        list: [
            // { icon: 'all', name: 'ערכה מלאה לתקשורת', link: window.site_url +'lnk_download/all/' + this.item.id + '?tk=' + this.$route.query.tk, is_active:false},
            // { icon: 'lyrics', name: 'מילים', link: window.site_url + 'lnk_download/press/' + this.item.id + '?type=lyrics&tk=' + this.$route.query.tk, is_active:false},
            // { icon: 'credits', name: 'קרדיטים', link: window.site_url + 'lnk_download/press/' + this.item.id + '?type=credits&tk=' + this.$route.query.tk, is_active:false},
            // { icon: 'gallery', name: 'גלרייה', link: window.site_url + 'lnk_download/gallery/' + this.item.id + '?tk=' + this.$route.query.tk, is_active:false},
            // { icon: 'song', name: 'הורדת השיר', link: '', is_active:false, type: 'download'},
            // { icon: 'press', name: 'הודעה לעיתונות', link: window.site_url + 'lnk_download/press/' + this.item.id + '?type=press_pdf&tk=' + this.$route.query.tk, is_active:false},
        ],
        song_formats: [
            { name: 'mp3', link: this.item.song_downloads.mp3.url },
            { name: 'mp2', link: this.item.song_downloads.mp2.url },
            { name: 'wav', link: this.item.song_downloads.wav.url },
        ]
    }
  },
  mounted(){
    this.list = this.item.downloads;
  },
  methods: {
    validateDownload(down){
       if (down.type == 'download') {
           if(this.checkLogged()) this.checkIsMediaUser();
       }
    }
  }
}
</script>

<style lang="scss" scoped>
#lt_downloads { 

    ul { display: flex; flex-wrap: wrap; margin:0 -15px;
        li { display: block; width:33%; flex-grow: 1; padding:0 15px; margin-bottom: 25px; }
        li .item { 
            &{ display: block; background: #fff; color: #000; height: 150px; text-align: center; border-radius: 12px; cursor: pointer; padding-top: 25px;
            
                @media (max-width: 600px) { height: 125px; }
            }
             
            i { display: block; height: 63px; mask-size: contain; background: #000; margin-bottom: 15px;
            
                @media (max-width: 600px) { height: 35px; }
            }
            span { display: block; text-align: center; font-weight: 600; padding:0 20px; font-size: 17px; 
            
                @media (max-width: 600px) { font-size: 13px; padding:0 5px; }
            }
            &.active, &:hover { background: #ff1661; color: #fff;
                i { background: #fff; }
            }
        }
    }

    .formats { text-align: center;
        a { display: inline-block; width: 80px; text-align: center; color: #fff !important;
            svg { font-size: 50px; margin-bottom: 6px; }
            span { display: block; font-size: 18px;}
        }
    }
 }

</style>